import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import {
  BulkSendAnnualStatementForSigningPageComponent
} from "./components/bulk-send-annual-statement-for-signing-page/bulk-send-annual-statement-for-signing-page.component";
import {
  BulkSendDocumentsForSigningPageComponent
} from "./components/bulk-send-documents-for-signing-page/bulk-send-documents-for-signing-page.component";

export function getBulkSendForESignRoutes(): Route[] {
  return [
    {
      title: 'Bulk Send Documents For Signing',
      path: 'bulk-send-documents-for-signing',
      component: BulkSendDocumentsForSigningPageComponent,
      canActivate: [authGuard]
    },
    {
      title: 'Bulk Send Annual Statement For Signing',
      path: 'bulk-send-annual-statement-for-signing',
      component: BulkSendAnnualStatementForSigningPageComponent,
      canActivate: [authGuard]
    },
  ];
}
